export default __webpack_public_path__ + "static/media/ButterflyPage1.9008a88c.txt";